import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { Playlist } from '../../api/rootstech/playlist/playlist.types'
import { getPlaylists as getPlaylistsApi } from '../../api'

type UsePlaylists = Omit<UseQueryResult, 'data'> & { playlists: Playlist[] }

export const usePlaylists = (): UsePlaylists => {
  const { data: playlists = [], ...rest } = useQuery({
    queryKey: ['playlists'],
    queryFn: async () => getPlaylistsApi(),
    staleTime: Infinity,
    select: ({ data }) => data.results as Playlist[],
  })
  return { playlists, ...rest }
}
